import { captureException, withScope } from '@sentry/browser';
import axios from 'axios';
import VcomProvider from '../../VcomProvider';
import HttpStatusCode from './const/HttpStatusCode';
import AlertService from '../alert/AlertService';
import WindowProvider from '../window/WindowProvider';
import TimeInMilliseconds from '../time/TimeInMilliseconds';
import TimeInSeconds from '../time/TimeInSeconds';
import translate from '../localization/translate';

axios.defaults.headers.common['X-REQUESTED-WITH'] = 'XMLHttpRequest';
axios.defaults.timeout = 240000;

const TWO_MINUTES = 2 * TimeInSeconds.MINUTE;

function redirectToLoginPage() {
  const loginPage = `${VcomProvider.baseUrl}/login`;
  setTimeout(
    () => { WindowProvider.location.href = loginPage; },
    TWO_MINUTES * TimeInMilliseconds.SECOND,
  );
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isUnauthorized = error.response?.status === HttpStatusCode.HTTP_UNAUTHORIZED;
    const isPasswordChangeUrl = error.request.responseURL?.endsWith('/user-profile/change-password') ?? false;
    if (isUnauthorized === true && isPasswordChangeUrl === false) {
      const loginPage = `${VcomProvider.baseUrl}/login`;
      const reloginMessage = translate('common.RELOGIN_MESSAGE', [loginPage]);
      AlertService.showError(reloginMessage, { TTL: TWO_MINUTES });
      redirectToLoginPage();
    } else {
      withScope((scope) => {
        const responseUrl = error.request.responseURL;
        const fingerprintUrl = responseUrl.indexOf('?') !== -1
          ? responseUrl.substring(0, responseUrl.indexOf('?'))
          : responseUrl;
        scope.setFingerprint([fingerprintUrl, String(error.response?.status)]);
        captureException(error);
      });
    }
    // eslint-disable-next-line fp/no-throw
    throw error;
  },
);

export default {
  get(endpoint, data = {}) {
    const url = `${VcomProvider.baseUrl}${endpoint}`;
    return axios.get(url, data);
  },

  post(endpoint, data = {}) {
    const url = `${VcomProvider.baseUrl}${endpoint}`;
    return axios.post(url, data);
  },
};
